import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CatalogService } from './services/catalog.service';
import { LoaderService } from '../../../shared/services/loader.service';
import { MatDialog } from '@angular/material/dialog';
import { NotificationModalComponent } from '../../../shared/components/notification-modal/notification-modal.component';
import { AsistenciaRapida, Motivo } from './models/priority-assistance.model';
import { ServicesService } from '../../services/services/services.service';
import { forkJoin } from 'rxjs';
@Component({
  selector: 'app-assistances',
  imports: [CommonModule],
  templateUrl: './assistances.component.html',
  styleUrl: './assistances.component.scss',
})
export class AssistancesComponent implements OnInit {
  constructor(
    private router: Router,
    private catalogService: CatalogService,
    private loader: LoaderService,
    private dialog: MatDialog,
    private servicesService: ServicesService
  ) { }

  asistencia: string = '';
  motivoAsistencia: string = '';
  motivos: Motivo[] = [];
  selectedOption: string | null = null;
  serviciosRapidos: AsistenciaRapida[] = [];
  selectedService: AsistenciaRapida | null = null;
  contactoDeWhatsApp: String = '+5215587196412';
  contactoDeTelefono: String = '5558094624';
  mensajeWhatsApp: string = 'Hola, me gustaría obtener más información.';

  // Cuentas que pueden ver la cruz médica
  private allowedAccounts = ['2228', '2665', '2559', '2907', '2988', '2997', '2998', '2999'];


  ngOnInit(): void {
    this.cargarCatalogosServiciosRapidos();
  }

  // Método para verificar si debe mostrar la cruz médica
  shouldShowMedicalCross(): boolean {
    const account = localStorage.getItem('account');
    return account ? this.allowedAccounts.includes(account) : false;
  }

  logOption(servicio: AsistenciaRapida) {
    this.selectedOption = this.selectedOption === servicio.dsSubservicio ? null : servicio.dsSubservicio;
    
    if (this.selectedOption) {
      this.selectedService = servicio;
      this.motivos = servicio.motivos;
      this.asistencia = servicio.dsServicio.toLowerCase();
      this.motivoAsistencia = '';
    } else {
      this.selectedService = null;
      this.motivos = [];
      this.asistencia = '';
      this.motivoAsistencia = '';
    }
  }

  getButtonClass(opcion: string): string {
    const base =
      'w-full border rounded-lg shadow p-4 text-left hover:shadow-md';

    if (this.selectedOption === opcion) {
      return `${base} bg-[#FFF8F4] border-[var(--assistance-border-option,#643F00)]`;
    }

    return this.selectedOption
      ? `${base} bg-[var(--assistance-bg,#FFEEDD)] border-[var(--assistance-txt_secondary,#643F00)]`
      : `${base} bg-[#ffeedd] border-[var(--assistance-border-option,#643F00)]`;
  }

  getMainButtonClass(): string {
    const base =
      'button-large w-full h-12 mt-6 rounded-full border py-2 transition';
    const isSelected = this.selectedOption !== null;

    return isSelected
      ? `${base} bg-[var(--assistance-btn_primary,#462A00)] text-white border-[var(--assistance-btn_primary,#462A00)]`
      : `${base} border-[var(--assistance-btn_primary,#462A00)] text-[var(--assistance-btn_primary,#462A00)] hover:bg-[var(--assistance-btn_primary,#462A00)] hover:text-white`;
  }

  getMotivoClass(motivo: string): string {
    const base = 'px-3 py-1 rounded-full mx-1 my-1';
    const isSelected = this.motivoAsistencia === motivo;

    return isSelected
      ? `${base} bg-[var(--assistance-btn_primary,#462A00)] border border-[var(--assistance-btn_primary,#462A00)] text-white`
      : `${base}  bg-[var(--assistance-btn-secondary,#FFEEDD)] border border-[var(--assistance-border-option,#643F00)] text-[var(--assistance-txt_secondary,#643F00)]`;
  }

  shouldShowInfo(opcion: string): boolean {
    return !this.selectedOption || this.selectedOption === opcion;
  }



  selectMotivo(motivo: string): void {
    this.motivoAsistencia = this.motivoAsistencia === motivo ? '' : motivo;
  }

  solicitarAhora() {
    if (!this.selectedService) {
      return;
    }

    const serviceData = {
      ...this.selectedService,
      motivo: this.motivoAsistencia
    };
    
    this.goToSubService(serviceData);
  }

  goToSubService(service: any) {
    // TODO: Descomentar después de pruebas - Validación de límite de servicios
    // const tomados = Number(service.Tomados || 0);
    // const disponibles = service.Disponibles === '00' ? Infinity : Number(service.Disponibles || 0);

    // if (tomados >= disponibles && disponibles !== Infinity) {
    //   this.dialog.open(NotificationModalComponent, {
    //     data: {
    //       type: 'info',
    //       title: 'Has alcanzado el límite de servicios disponibles.',
    //       message: 'Si tienes servicios en curso, puedes consultar su detalle en el apartado "<b>Solicitudes</b>".'
    //     }
    //   });
    //   return;
    // }

    const solicitudData = {
      servicio: {
        clServicio: service.clServicio,
        clSubservicio: service.clSubservicio,
        dsServicio: service.dsServicio,
        dsSubServicio: service.dsSubservicio
      }
    };
    localStorage.setItem('solicitudData', JSON.stringify(solicitudData));

    this.router.navigate(
      ['/service', service.clSubservicio],
      { state: service }
    );
  }

  goToCall() {
    window.open(`tel:${this.contactoDeTelefono}`, '_self');
  }

  goToWhatsApp() {
    const mensaje = encodeURIComponent(this.mensajeWhatsApp);
    const url = `https://wa.me/${this.contactoDeWhatsApp.replace('+', '')}?text=${mensaje}`;
    window.open(url, '_blank');
  }

  goToSolicitudes() {
    this.router.navigate(['/solicitudes']);
  }

  cargarCatalogosServiciosRapidos() {
    this.loader.show();
    const account = localStorage.getItem('account') || '0';
    
    forkJoin({
      serviciosRapidos: this.catalogService.getServiciosRapidos(account),
      serviciosPopulares: this.servicesService.getServicesPopular()
    }).subscribe({
      next: ({ serviciosRapidos, serviciosPopulares }) => {
        if (serviciosRapidos.success && serviciosPopulares.code === 200) {
          // Crear mapa de servicios populares por clSubServicio
          const serviciosMap = new Map(
            serviciosPopulares.data.map((s: any) => [s.clSubServicio, s])
          );
          
          // Combinar datos: agregar Tomados y Disponibles a serviciosRapidos
          this.serviciosRapidos = serviciosRapidos.asistenciaRapida.map((servicio: any) => {
            const servicioPopular = serviciosMap.get(servicio.clSubservicio);
            return {
              ...servicio,
              Tomados: servicioPopular?.Tomados || '0',
              Disponibles: servicioPopular?.Disponibles || '00'
            };
          });
          
          if (this.serviciosRapidos.length > 0) {
            this.logOption(this.serviciosRapidos[0]);
          }
        }
        this.loader.hide();
      },
      error: (error) => {
        console.error('Error al cargar servicios:', error);
        this.loader.hide();
      },
    });
  }
}
